"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Modal = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Modal"));
var _ModalHeader = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalHeader"));
var _ModalBody = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalBody"));
var _ModalFooter = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/ModalFooter"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _modals = require("../../../utils/modals");
var ConfirmationModal = function ConfirmationModal(_ref) {
  var closeModal = _ref.closeModal,
    onConfirm = _ref.onConfirm;
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    onEnter: closeModal,
    onEsc: closeModal,
    onClickOverlay: closeModal,
    renderInBody: false,
    testId: "promote-ls-modal"
  }, /*#__PURE__*/_react.default.createElement(_ModalHeader.default, {
    testId: "promote-ls-modal-header"
  }, /*#__PURE__*/_react.default.createElement("h1", null, "Promote Asset Version")), /*#__PURE__*/_react.default.createElement(_ModalBody.default, {
    testId: "promote-ls-body"
  }, /*#__PURE__*/_react.default.createElement("p", null, "This operation is not reversible."), /*#__PURE__*/_react.default.createElement("p", null, "Do you want to promote the asset version to ", /*#__PURE__*/_react.default.createElement("b", null, "Stable"), "?")), /*#__PURE__*/_react.default.createElement(_ModalFooter.default, null, /*#__PURE__*/_react.default.createElement(_Button.default, {
    kind: "tertiary",
    testId: "cancel-button",
    onClick: function onClick() {
      return closeModal();
    },
    noFill: true
  }, "Cancel"), /*#__PURE__*/_react.default.createElement(_Button.default, {
    kind: "primary",
    testId: "promote-button",
    onClick: onConfirm
  }, "Promote")));
};
var ConfirmationModalContainer = (0, _modals.setModalName)('ConfirmationModal')(ConfirmationModal);
var _default = exports.default = ConfirmationModalContainer;
//# sourceMappingURL=ConfirmationModal.js.map